import { useDispatch, useSelector } from "react-redux";

import {
  ActionButtonsContainer,
  FieldDesc,
  FieldName,
  LinkPodcast,
  SideMenuAlbumImg,
  SideMenuContainer,
  SideMenuContent,
  SideMenuContentInfo,
  SideMenuContentInfoField,
  SideMenuDesc,
  SideMenuInner,
} from "../styled";
import { Link } from "react-router-dom";
import { formatDate } from "../../../utils/utils";
import { Button } from "../../Button/Button";
import {
  pause,
  playMedia,
  setCurrentContent,
} from "../../../redux/Slice/playerSlice";
import { closeModal } from "../../../redux/Slice/modalSlice";
import {
  selectCurrentContent,
  selectIsPlaying,
} from "../../../redux/selectors/playerSelector";
import { setPlaylistReleases } from "../../../redux/Slice/playlistReleasesSlice";
import { useGetPodcastsQuery } from "../../../api/podcastsApi";
import { ShareButton } from "../../ShareButton";
import { LikePodcastBtnWrapper } from "../../LikeTrackBtn/LikePodcastBtnWrapper";
import { useFooterPlayer } from "../../../contexts/FooterPlayerContext";

const ReleasePodcastInfo = ({ release }) => {
  const releaseInfo = useSelector((state) => state.releasePodcastInfo);
  const currentRelease = (releaseInfo?.id ? releaseInfo : release) || {};

  const { footerPlayerRef } = useFooterPlayer();

  const { data: podcast, isSuccess: isPodcastSuccess } = useGetPodcastsQuery({
    link: currentRelease.podcastLink,
  });

  const formattedDate = formatDate(currentRelease.publishedAt);

  const dispatch = useDispatch();
  const currentContent = useSelector(selectCurrentContent);
  const isPlaying = useSelector(selectIsPlaying);

  const handlePlayClick = () => {
    if (currentContent.id === currentRelease.id && isPlaying) {
      dispatch(pause());
      return;
    }

    dispatch(setCurrentContent(currentRelease));
    dispatch(playMedia(currentRelease.audioFileLink));

    if (isPodcastSuccess && podcast?.podcastReleases) {
      dispatch(
        setPlaylistReleases(
          podcast.podcastReleases.filter((item) => !item.isLive),
        ),
      );
    }
  };

  const handlePodcastLinkClick = () => {
    dispatch(closeModal());
  };

  return (
    <SideMenuContainer
      footerPlayerHeight={footerPlayerRef.current?.offsetHeight ?? 0}
    >
      <SideMenuInner>
        <SideMenuContent>
          <SideMenuAlbumImg
            src={currentRelease.cover?.big || "/coverMissing.png"}
          />
          <SideMenuContentInfo>
            <SideMenuContentInfoField>
              <FieldName>Выпуск</FieldName>
              <FieldDesc>{currentRelease.title}</FieldDesc>
            </SideMenuContentInfoField>
            <SideMenuContentInfoField>
              <FieldName>Подкаст</FieldName>
              <LinkPodcast onClick={handlePodcastLinkClick}>
                <Link to={`/podcasts/${currentRelease.podcastLink}`}>
                  {currentRelease.podcastTitle}
                </Link>
              </LinkPodcast>
            </SideMenuContentInfoField>
            <SideMenuContentInfoField>
              <FieldName>Дата выхода</FieldName>
              <FieldDesc>{formattedDate}</FieldDesc>
            </SideMenuContentInfoField>
          </SideMenuContentInfo>
        </SideMenuContent>
        {currentRelease.description && (
          <SideMenuDesc>{currentRelease.description}</SideMenuDesc>
        )}
        <ActionButtonsContainer>
          <Button variant="orange" type="button" onClick={handlePlayClick}>
            Слушать
            {isPlaying && currentRelease.id === currentContent.id ? (
              <img src="/pause.svg" alt="Пауза" width={16} height={16} />
            ) : (
              <img src="/play.svg" alt="Слушать" width={16} height={16} />
            )}
          </Button>
          <LikePodcastBtnWrapper release={currentRelease} withBgColor />
          <ShareButton
            shareData={{
              title: currentRelease.title,
              url: `${window.location.origin}/podcasts/${currentRelease.podcastLink}/${currentRelease.trackLink}`,
            }}
          />
        </ActionButtonsContainer>
      </SideMenuInner>
    </SideMenuContainer>
  );
};

export default ReleasePodcastInfo;
